import { QueryClient } from '@tanstack/react-query'
import { ApiRequestError } from './api'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // A 4xx will not fix itself on retry.
        if (error instanceof ApiRequestError && error.status < 500) return false
        return failureCount < 2
      },
    },
  },
})
